import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/NominateRequest/NominateRequestDetails.css';
import createappointmentimg from '../../../Assets/TruckVisits/Assets-Desktop/create-appointment.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class NominateRequestDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            search: "",
            searchlength: 0,
            nominatetempData: [],
            errorMessage: false,
            nominateReqDetails: [
                {
                    'orderId': '101',
                    'orderDate': '1613110942',
                    'vesselName': 'COSCO SURABAYA',
                    'vesselStatus': 'Open'
                },
                {
                    'orderId': '102',
                    'orderDate': '1613110942',
                    'vesselName': 'COSCO SURABAYA',
                    'vesselStatus': 'Open'
                },
                {
                    'orderId': '103',
                    'orderDate': '1613110942',
                    'vesselName': 'COSCO SURABAYA',
                    'vesselStatus': 'Closed'
                },
                {
                    'orderId': '101',
                    'orderDate': '1613110942',
                    'vesselName': 'COSCO SURABAYA',
                    'vesselStatus': 'Open'
                },
                {
                    'orderId': '102',
                    'orderDate': '1613110942',
                    'vesselName': 'COSCO SURABAYA',
                    'vesselStatus': 'Open'
                },
                {
                    'orderId': '103',
                    'orderDate': '1613110942',
                    'vesselName': 'COSCO SURABAYA',
                    'vesselStatus': 'Closed'
                }
            ],
        }
        this.handlechangeSearchAppointmentNo = this.handlechangeSearchAppointmentNo.bind(this);
    }
    componentDidMount = () => {
    }
    handleDetails = (index) => {
        this.state.nominatetempData?.find((truckdataStore) => {
            if (truckdataStore?.orderId === this.state.nominatetempData[index]?.orderId) {
                // 
            }
        })
    }
    handlechangeSearchAppointmentNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value?.length,
            errorMessage: false
        });
    };
    createRequest = () => {
        this.props.history.push('/')
    }
    searchByOrderId = () => {
        if (this.state.searchlength > 0) {
            const truckdatafilter = this.state.nominateReqDetails?.filter(i => i.orderId == this.state.search)
            console.log('a---', truckdatafilter);
            this.setState({ nominatetempData: truckdatafilter });
            if (truckdatafilter?.length === 0) {
                this.setState({ errorMessage: true });
            }
            else {
                this.setState({ errorMessage: false });
            }
            console.log("inside search function", this.state.nominatetempData);
        }
    }
    render() {
        if (this.state.searchlength == 0) {
            this.state.nominatetempData = this.state.nominateReqDetails;
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.truckAppointmentPageTitle} description={TitleDescription.truckAppointmentPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Nominate Request</small>
                            </div>
                            <div id="TruckAppointmentAcceptMobile" className="TruckAppointmentNavbarNameRight">
                                <a onClick={() => this.createRequest()}><img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                    <small id="adsh1saveEnable" >Create Request</small></a>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <>
                            <nav class="TruckAppointmentMobileNavbar">
                                <div className="TruckAppointmentNavbarNameRight">
                                    <a onClick={() => this.createRequest()}><img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                        <small id="adsh1saveEnable" >Create Request</small></a>
                                </div>
                            </nav>
                        </>
                        <div class="notificationmaincardNRD">
                            <div class="concsdivlow111">
                                <div class="csdivlow222">
                                    <input
                                        className="appointmentSearch"
                                        placeholder="Search by Order ID"
                                        autoComplete="off"
                                        id="secrchInput1"
                                        onChange={this.handlechangeSearchAppointmentNo}
                                        value={this.state.search}
                                    ></input>
                                    <img onClick={this.searchByOrderId} id="search_img" src={searchimg} width="16" height="16" />
                                </div>
                            </div>
                            <div id="DataTopDivTruckAppointment">
                                {!this.state.errorMessage ?
                                    (this.state.nominatetempData?.map((name, index) => {
                                        return (
                                            <div class="NominateDetailsMainCardDiv" onClick={() => this.handleDetails(index)}>
                                                <div class="NominateDetailsDivRow" >
                                                    <div class="NominateMainColumn1">
                                                        <div class='NominateMainColumn'>
                                                            <small id="NominateDetailsLable">Order ID</small>
                                                            <small id='NominateDetailsValue'>{name?.orderId}</small>
                                                        </div>
                                                        <div class='NominateMainColumn'>
                                                            <small id="NominateDetailsLable">Order Date & Time</small>
                                                            <small id='NominateDetailsValue'>{FormatTimeStamp(name?.orderDate)?.timedate}</small>
                                                        </div>
                                                        <div class='NominateMainColumn'>
                                                            <small id="NominateDetailsLable">Vessel Name</small>
                                                            <small id='NominateDetailsValue'>{name?.vesselName}</small>
                                                        </div>
                                                        <div class='NominateMainColumn'>
                                                            <small id="NominateDetailsLable">Order Status</small>
                                                            <small id={name.vesselStatus == 'Open' ? 'NominateDetailsValueGreen' : "NominateDetailsValueRed"}>{name?.vesselStatus}</small>
                                                        </div>
                                                    </div>
                                                    <div class="NominateDetailsArrow" >
                                                        <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))
                                    :
                                    <div class="notruckfound1">
                                        <small id="nodatamessage1">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default NominateRequestDetails;